export const deepFind = (obj: any, predicate: (item: any) => boolean): boolean => {
    if (Array.isArray(obj)) {
        return obj.some((item: any) => deepFind(item, predicate))
    }

    if (typeof obj === 'object') {
        return Object.values(obj).some((item: any) => deepFind(item, predicate))
    }

    return predicate(obj)
}
